import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

// app
import { QB_RISK_DETAILS, QB_RISK_QUOTES, quoteBindAxios } from 'lib/quoteBind';
import isEmpty from 'lodash/isEmpty';
import { enqueueNotification, hideModal } from 'stores';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

// risks
export const usePostPostBindInfo = () => {
  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.mutations.usePostPostBindInfo',
    };

    dispatch(enqueueNotification('notification.generic.request', 'error'));

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = (riskId, result) => {
    queryClient.invalidateQueries(QB_RISK_DETAILS, { id: riskId });
    queryClient.invalidateQueries([QB_RISK_QUOTES, { id: riskId }]);

    dispatch(hideModal());
    dispatch(enqueueNotification('notification.preBindInfo.postSuccess', 'success'));

    return result;
  };

  return useMutation(
    async ({ riskId, body }) => {
      if (isEmpty(body) || !riskId) {
        throw new Error('Invalid params');
      }

      const result = await quoteBindAxios.post(`risks/${riskId}/post-bind`, body);

      return { result, riskId };
    },
    {
      onSuccess: ({ riskId, result }) => handleSuccess(riskId, result),
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
